import PropTypes from 'prop-types';
import { useEffect, memo } from 'react';
import { useDispatch } from 'react-redux';

import Tabs from 'core/tabs/Tabs';
import CustomerKycsTab from './tabs/CustomerKycsTab';
import CustomerDetailsTab from './tabs/CustomerDetailsTab';
import CustomerKycLogsTab from './tabs/CustomerKycLogsTab';
import CustomerTransactionsTab from './tabs/CustomerTransactionsTab';
import CustomerBeneficiariesTab from './tabs/CustomerBeneficiariesTab';

import Auth from 'utils/Auth';
import { getCustomer } from 'app/features/customers/customerSaga';
import { useLocation } from 'react-router-dom';

// function Customer({ customerId }) {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(getCustomer(customerId));
//   }, [customerId]);

//   return (
//     <Tabs
//       tabs={[
//         {
//           key: 'customer-details',
//           tabName: 'General Details',
//           tabContent: <CustomerDetailsTab />,
//         },
//         {
//           key: 'customer-beneficiaries',
//           tabName: 'Beneficiaries',
//           tabContent: <CustomerBeneficiariesTab customerId={customerId} />,
//         },
//         ...(Auth.isSuperAdmin() || Auth.isAdmin()
//           ? [
//               {
//                 key: 'customer-kycs',
//                 tabName: 'KYCs',
//                 tabContent: <CustomerKycsTab customerId={customerId} />,
//               },
//               {
//                 key: 'customers-kyc-logs',
//                 tabName: 'KYC Logs',
//                 tabContent: <CustomerKycLogsTab customer_id={customerId} />,
//               },

//               {
//                 key: 'customer-transactions',
//                 tabName: 'Transactions',
//                 tabContent: <CustomerTransactionsTab customerId={customerId} />,
//               },
//             ]
//           : []),
//       ]}
//     />
//   );
// }

// export default memo(Customer);

// Customer.propTypes = {
//   customerId: PropTypes.string.isRequired,
// };

function Customer({ customerId }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const activeTab = location.state?.activeTab || 'customer-details';

  useEffect(() => {
    dispatch(getCustomer(customerId));
  }, [customerId]);

  return (
    <Tabs
      defaultActiveKey={activeTab}
      tabs={[
        {
          key: 'customer-details',
          tabName: 'General Details',
          tabContent: <CustomerDetailsTab />,
        },
        {
          key: 'customer-beneficiaries',
          tabName: 'Beneficiaries',
          tabContent: <CustomerBeneficiariesTab customerId={customerId} />,
        },
        {
          key: 'customer-kycs',
          tabName: 'KYCs',
          tabContent: <CustomerKycsTab customerId={customerId} />,
        },
        {
          key: 'customers-kyc-logs',
          tabName: 'KYC Logs',
          tabContent: <CustomerKycLogsTab customer_id={customerId} />,
        },
        {
          key: 'customer-transactions',
          tabName: 'Transactions',
          tabContent: <CustomerTransactionsTab customerId={customerId} />,
        },
      ]}
    />
  );
}

export default memo(Customer);

Customer.propTypes = {
  customerId: PropTypes.string.isRequired,
};
